/* YVORA Collage V1.12 · written for the phone first */
(function () {
  'use strict';

  var routes = window.xoRoutes || { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart', root: '/' };
  var text = window.xoText || {};
  function say(key, fallback) {
    return typeof text[key] === 'string' && text[key] ? text[key] : fallback;
  }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }
  function remember(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {}
  }
  function recall(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  /* ---------- Sheets: menu, bag, size guide ---------- */
  function openSheet(name) {
    var sheet = document.getElementById('xo-' + name);
    if (!sheet || typeof sheet.showModal !== 'function') return false;
    if (!sheet.open) sheet.showModal();
    return true;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-xo-open]');
    if (opener) {
      if (openSheet(opener.getAttribute('data-xo-open'))) event.preventDefault();
      return;
    }
    var closer = event.target.closest('[data-xo-close]');
    if (closer) {
      var parent = closer.closest('dialog');
      if (parent) parent.close();
      return;
    }
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('xo-sheet')) {
      event.target.close();
    }
  });

  /* ---------- Tiles: a colour dot shows the piece in that colour ---------- */
  function setPhoto(image, url) {
    if (!image || !url) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = url;
  }

  function pickDot(dot) {
    var tile = dot.closest('[data-xo-tile]');
    if (!tile) return;
    var main = dot.getAttribute('data-main');
    var alt = dot.getAttribute('data-alt');
    setPhoto($('.xo-tile__img:not(.xo-tile__img--alt)', tile), main);
    setPhoto($('.xo-tile__img--alt', tile), alt || main);
    setPhoto($('.xo-tile__satimg', tile), alt || main);
    $all('[data-xo-tile-link]', tile).forEach(function (link) {
      link.setAttribute('href', dot.getAttribute('data-href'));
    });
    $all('[data-xo-dot]', tile).forEach(function (other) {
      other.setAttribute('aria-pressed', String(other === dot));
    });
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('[data-xo-dot]');
    if (dot) pickDot(dot);
  });

  /* ---------- Collection: ?colour=Name shows only the pieces that come in that colour, in that colour ----------
     The pieces that stay are given their places in the rhythm anew, so the layout closes up. */
  function initColourFilter() {
    var tiles = $('[data-xo-tiles]');
    if (!tiles) return;
    var wanted = '';
    try {
      wanted = (new URLSearchParams(window.location.search).get('colour') || '').trim();
    } catch (error) {
      wanted = '';
    }
    if (!wanted) return;
    var key = wanted.toLowerCase();
    var kept = 0;
    $all('[data-xo-tile]', tiles).forEach(function (tile) {
      var colours = (tile.getAttribute('data-colours') || '').split('|').map(function (name) {
        return name.trim().toLowerCase();
      });
      var at = colours.indexOf(key);
      if (at < 0) {
        tile.remove();
        return;
      }
      var dot = $all('[data-xo-dot]', tile).filter(function (candidate) {
        return (candidate.getAttribute('data-colour') || '').trim().toLowerCase() === key;
      })[0];
      if (dot) pickDot(dot);
      var slot = (kept % 7) + 1;
      tile.className = tile.className.replace(/\bxo-tile--\d\b/, 'xo-tile--' + slot);
      var sat = $('.xo-tile__sat', tile);
      if (sat && slot !== 1 && slot !== 2 && slot !== 4) {
        sat.hidden = true;
        tile.classList.remove('has-sat');
      }
      kept += 1;
    });
    var count = $('[data-xo-count]');
    if (count) count.textContent = (kept === 1 ? say('pieceOne', '1 piece') : say('pieceMany', '2 pieces')).replace(/\d+/, String(kept));
    var note = $('[data-xo-colour-note]');
    if (note) {
      var name = $('[data-xo-colour-name]', note);
      if (name) name.textContent = say('inColour', 'In %s').replace('%s', wanted);
      note.hidden = false;
    }
    tiles.classList.toggle('xo-tiles--open', kept % 7 === 6);
    tiles.setAttribute('data-filtered', '');
  }

  /* ---------- Collection: Editorial or Grid ---------- */
  function initView() {
    var tiles = $('[data-xo-tiles]');
    var buttons = $all('[data-xo-view]');
    if (!tiles || !buttons.length) return;
    function apply(view) {
      tiles.setAttribute('data-view', view);
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-xo-view') === view));
      });
    }
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var view = button.getAttribute('data-xo-view');
        apply(view);
        remember('xo-view', view);
      });
    });
    if (recall('xo-view') === 'grid') apply('grid');
  }

  /* ---------- Product photos: tap to enlarge, swipe for the next, small photos to jump ---------- */
  /* The enlarged photo fills the window and is moved by scrolling. One for the page, shared by every colour. */
  var zoom = null;
  function initZoom() {
    var dialog = $('[data-xo-zoom]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var image = $('[data-xo-zoom-img]', dialog);
    var scroller = $('[data-xo-zoom-scroll]', dialog);
    var count = $('[data-xo-zoom-count]', dialog);
    var steps = $all('[data-xo-zoom-step]', dialog);
    var state = null;

    function centre(focus) {
      scroller.scrollLeft = Math.max(0, image.offsetWidth * focus.x - scroller.clientWidth / 2);
      scroller.scrollTop = Math.max(0, image.offsetHeight * focus.y - scroller.clientHeight / 2);
    }
    function paint(focus) {
      var item = state.list[state.index];
      /* Until the large file is there, the photo already on the page stands in at the same size. */
      image.style.aspectRatio = state.ratio ? String(state.ratio) : '';
      image.style.backgroundImage = item.low ? 'url("' + item.low + '")' : 'none';
      image.alt = item.alt || '';
      image.src = item.src;
      count.textContent = state.list.length > 1 ? state.index + 1 + ' / ' + state.list.length : '';
      steps.forEach(function (button) {
        button.hidden = state.list.length < 2;
      });
      centre(focus);
      window.requestAnimationFrame(function () {
        centre(focus);
      });
    }
    function step(by) {
      if (!state || state.list.length < 2) return;
      var focus = {
        x: image.offsetWidth ? (scroller.scrollLeft + scroller.clientWidth / 2) / image.offsetWidth : 0.5,
        y: image.offsetHeight ? (scroller.scrollTop + scroller.clientHeight / 2) / image.offsetHeight : 0.5
      };
      state.index = (state.index + by + state.list.length) % state.list.length;
      if (state.gallery.xoShow) state.gallery.xoShow(state.index);
      paint(focus);
    }

    steps.forEach(function (button) {
      button.addEventListener('click', function () {
        step(parseInt(button.getAttribute('data-xo-zoom-step'), 10) || 1);
      });
    });
    scroller.addEventListener('click', function () {
      dialog.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') step(1);
      if (event.key === 'ArrowLeft') step(-1);
    });
    dialog.addEventListener('close', function () {
      image.removeAttribute('src');
      image.style.backgroundImage = 'none';
      state = null;
    });

    zoom = function (gallery, list, index, ratio, focus) {
      if (!list.length) return;
      state = { gallery: gallery, list: list, index: index, ratio: ratio };
      if (!dialog.open) dialog.showModal();
      paint(focus);
    };
  }

  function initGallery(gallery) {
    var fig = $('[data-xo-fig]', gallery);
    var thumbs = $all('[data-xo-thumb]', gallery);
    var counter = $('[data-xo-counter]', gallery);
    if (!fig) return;
    var many = thumbs.length > 1;
    var index = 0;
    var ticket = 0;

    function shownImage() {
      var images = $all('img.xp-fig__img', fig);
      return images.length ? images[images.length - 1] : null;
    }
    if (!shownImage()) return;
    fig.classList.add('is-zoomable');

    function show(next) {
      if (!many) return;
      next = (next + thumbs.length) % thumbs.length;
      if (next === index) return;
      index = next;
      thumbs.forEach(function (thumb, position) {
        thumb.setAttribute('aria-current', String(position === index));
      });
      if (counter) counter.textContent = index + 1 + ' / ' + thumbs.length;

      var old = $all('.xp-fig__img', fig);
      var image = document.createElement('img');
      var mine = ++ticket;
      image.className = 'xp-fig__img is-fading';
      image.alt = old.length ? old[old.length - 1].alt || '' : '';
      image.setAttribute('sizes', '(min-width: 901px) 46vw, 92vw');
      function place() {
        if (mine !== ticket) return;
        fig.appendChild(image);
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            image.classList.remove('is-fading');
          });
        });
        window.setTimeout(
          function () {
            old.forEach(function (node) {
              if (node.parentNode === fig) fig.removeChild(node);
            });
          },
          reduceMotion ? 0 : 420
        );
      }
      image.addEventListener('load', place);
      image.addEventListener('error', place);
      image.setAttribute('srcset', thumbs[index].getAttribute('data-srcset') || '');
      image.src = thumbs[index].getAttribute('data-src');
    }

    /* Everything the enlarged view needs: the large file of each photo, and a small one to stand in while it loads. */
    function enlarge(event) {
      var shown = shownImage();
      if (!zoom || !shown) return;
      var here = shown.currentSrc || shown.src;
      var list = many
        ? thumbs.map(function (thumb, position) {
            var small = $('img', thumb);
            return {
              src: thumb.getAttribute('data-zoom') || thumb.getAttribute('data-src'),
              low: position === index ? here : small ? small.currentSrc || small.src : '',
              alt: shown.alt
            };
          })
        : [{ src: fig.getAttribute('data-zoom') || here, low: here, alt: shown.alt }];
      var box = fig.getBoundingClientRect();
      var focus = { x: 0.5, y: 0.4 };
      if (event && box.width && box.height && typeof event.clientX === 'number' && (event.clientX || event.clientY)) {
        focus = { x: (event.clientX - box.left) / box.width, y: (event.clientY - box.top) / box.height };
      }
      var ratio = shown.naturalWidth && shown.naturalHeight ? shown.naturalWidth / shown.naturalHeight : 0;
      zoom(gallery, list, index, ratio, focus);
    }

    thumbs.forEach(function (thumb, position) {
      thumb.addEventListener('click', function () {
        show(position);
      });
    });


    /* A swipe sideways shows the next photo; a tap or click enlarges the one shown. */
    var start = null;
    var swiped = false;
    fig.addEventListener('pointerdown', function (event) {
      start = { x: event.clientX, y: event.clientY };
      swiped = false;
    });
    fig.addEventListener('pointercancel', function () {
      start = null;
    });
    fig.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
    fig.addEventListener('pointerup', function (event) {
      if (!start) return;
      var dx = event.clientX - start.x;
      var dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        show(index + (dx < 0 ? 1 : -1));
      } else if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
        swiped = true;
      }
    });
    fig.addEventListener('click', function (event) {
      if (swiped) {
        swiped = false;
        return;
      }
      enlarge(event);
    });
    fig.setAttribute('tabindex', '0');
    fig.setAttribute('role', 'button');
    fig.setAttribute('aria-label', say('enlarge', 'Enlarge the photo'));
    fig.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') show(index + 1);
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        enlarge(null);
      }
    });

    gallery.xoShow = show;
    gallery.xoReset = function () {
      show(0);
    };
  }

  /* ---------- Size guide: centimetres or inches, the chosen size marked ---------- */
  function toInches(text) {
    function inch(value) {
      return (parseFloat(value.replace(',', '.')) / 2.54).toFixed(1);
    }
    return String(text)
      .replace(/(\d+(?:[.,]\d+)?)\s*(?:–|-)\s*(\d+(?:[.,]\d+)?)\s*cm/g, function (match, from, to) {
        return inch(from) + '–' + inch(to) + ' in';
      })
      .replace(/(\d+(?:[.,]\d+)?)\s*cm/g, function (match, value) {
        return inch(value) + ' in';
      });
  }
  function initSizeGuide(chosenSize) {
    var guide = document.getElementById('xo-size-guide');
    if (!guide) return;
    var cells = $all('td', guide);
    var buttons = $all('[data-xo-unit]', guide);
    cells.forEach(function (cell) {
      cell.setAttribute('data-cm', cell.textContent);
    });
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var unit = button.getAttribute('data-xo-unit');
        buttons.forEach(function (other) {
          other.setAttribute('aria-pressed', String(other === button));
        });
        cells.forEach(function (cell) {
          var metric = cell.getAttribute('data-cm');
          cell.textContent = unit === 'in' ? toInches(metric) : metric;
        });
      });
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-xo-open="size-guide"]')) return;
      var size = String(chosenSize() || '').toLowerCase();
      $all('tr[data-size]', guide).forEach(function (row) {
        row.classList.toggle('is-sel', size !== '' && row.getAttribute('data-size').toLowerCase() === size);
      });
    });
  }

  /* ---------- Product: colour, size, add to bag ---------- */
  function initProduct(root) {
    var dataNode = $('[data-xo-variants]', root);
    var variants = [];
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (error) {}
    var form = $('[data-xo-form]', root);
    var idInput = $('[data-xo-id]', root);
    var priceNode = $('[data-xo-price]', root);
    var addButton = $('[data-xo-add]', root);
    var errorNode = $('[data-xo-error]', root);
    var inputs = $all('input[data-xo-option]', root);
    var colourPosition = parseInt(root.getAttribute('data-colour-position'), 10) || 0;
    var galleries = $all('[data-xo-gallery]', root);
    var colourName = $('[data-xo-colour-name]', root);
    var bar = $('[data-xo-bar]', root);
    var barButton = $('[data-xo-bar-add]', root);
    var barChoice = $('[data-xo-bar-choice]', root);
    var toastNode = $('[data-xo-toast]', root);
    var toastTimer = null;
    var labelAdd = addButton ? addButton.getAttribute('data-label-add') || 'Add to bag' : 'Add to bag';
    var labelSoldOut = addButton ? addButton.getAttribute('data-label-soldout') || 'Sold out' : 'Sold out';
    var busy = false;

    galleries.forEach(initGallery);

    function isColour(input) {
      return parseInt(input.getAttribute('data-xo-option'), 10) === colourPosition;
    }
    var sizeInputs = inputs.filter(function (input) {
      return !isColour(input);
    });

    function toast(message) {
      if (!toastNode || !message) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-on');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toastNode.classList.remove('is-on');
      }, 2400);
    }

    function selection() {
      var chosen = {};
      inputs.forEach(function (input) {
        if (input.checked) chosen[input.getAttribute('data-xo-option')] = input.value;
      });
      return chosen;
    }
    /* True while a size (or another option that is not the colour) still has to be chosen. */
    function sizeMissing() {
      var chosen = selection();
      return sizeInputs.some(function (input) {
        return !(input.getAttribute('data-xo-option') in chosen);
      });
    }
    function chosenSize() {
      var input = sizeInputs.filter(function (item) {
        return item.checked;
      })[0];
      return input ? input.value : '';
    }
    function matches(variant, chosen) {
      for (var position in chosen) {
        if (variant.options[parseInt(position, 10) - 1] !== chosen[position]) return false;
      }
      return true;
    }
    function findVariant(chosen) {
      var fallback = null;
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], chosen)) {
          if (variants[i].available) return variants[i];
          if (!fallback) fallback = variants[i];
        }
      }
      return fallback;
    }

    function showColour() {
      if (!colourPosition) return;
      var input = inputs.filter(function (item) {
        return item.checked && isColour(item);
      })[0];
      if (!input) return;
      if (colourName) colourName.textContent = input.value;
      inputs.filter(isColour).forEach(function (item) {
        var chip = item.closest('.xp-chip');
        if (chip) chip.classList.toggle('is-on', item.checked);
      });
      galleries.forEach(function (gallery) {
        var show = gallery.getAttribute('data-colour') === input.value;
        if (show && gallery.hidden) {
          if (gallery.xoReset) gallery.xoReset();
          gallery.hidden = false;
        } else if (!show) {
          gallery.hidden = true;
        }
      });
    }

    function setButtons(label, disabled) {
      [addButton, barButton].forEach(function (button) {
        if (!button) return;
        button.textContent = label;
        button.disabled = disabled;
      });
    }

    function refresh(pushUrl) {
      var chosen = selection();

      sizeInputs.forEach(function (input) {
        var probe = {};
        for (var key in chosen) probe[key] = chosen[key];
        probe[input.getAttribute('data-xo-option')] = input.value;
        var available = variants.some(function (variant) {
          return variant.available && matches(variant, probe);
        });
        var label = input.closest('.xp-size');
        if (label) label.classList.toggle('is-out', !available);
      });

      var names = [];
      for (var position in chosen) names.push(chosen[position]);
      if (barChoice) barChoice.textContent = names.join(' · ');

      var variant = findVariant(chosen);
      if (!variant) {
        /* This colour is not made in this size: nothing may be added. */
        if (idInput) idInput.value = '';
        if (!busy) setButtons(labelSoldOut, true);
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNode) priceNode.innerHTML = variant.price;
      if (!busy) {
        /* Without a size chosen this is the first size still to be had in the colour; sold out only if none is. */
        var open = variant.available;
        setButtons(open ? labelAdd : labelSoldOut, !open);
      }
      if (errorNode) errorNode.hidden = true;
      if (pushUrl && !sizeMissing() && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        url.searchParams.delete('pick');
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* A link to one exact variant (from the bag, a reload after choosing, an advert) arrives with its size chosen.
       A link from a tile names a variant only to carry the colour (pick=colour): there no size is chosen. */
    var pickedId = root.getAttribute('data-picked');
    if (pickedId && new URLSearchParams(window.location.search).get('pick') !== 'colour') {
      var pickedVariant = variants.filter(function (variant) {
        return String(variant.id) === pickedId;
      })[0];
      if (pickedVariant) {
        sizeInputs.forEach(function (input) {
          var position = parseInt(input.getAttribute('data-xo-option'), 10);
          if (pickedVariant.options[position - 1] === input.value) input.checked = true;
        });
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (isColour(input)) showColour();
        $all('.xp-sizes', root).forEach(function (box) {
          box.classList.remove('is-missing');
        });
        refresh(true);
      });
    });
    refresh(false);
    initSizeGuide(chosenSize);

    /* On wide screens the bar comes in once the button itself is out of sight. On phones the stylesheet keeps it in place. */
    var cta = $('[data-xo-cta]', root);
    if (bar && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-on', !entries[entries.length - 1].isIntersecting);
      }).observe(cta);
    }
    if (barButton && form) {
      barButton.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(addButton);
        else if (addButton) addButton.click();
      });
    }

    function askForSize() {
      var box = $('.xp-sizes', root);
      toast(toastNode ? toastNode.getAttribute('data-size') : '');
      if (!box) return;
      box.classList.add('is-missing');
      box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var first = $('input', box);
      if (first) first.focus({ preventScroll: true });
    }

    if (form && addButton) {
      form.addEventListener('submit', function (event) {
        if (sizeMissing()) {
          event.preventDefault();
          askForSize();
          return;
        }
        if (!window.fetch) return;
        event.preventDefault();
        busy = true;
        setButtons(say('adding', 'Adding'), true);
        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                var refused = new Error(data.description || data.message || '');
                refused.fromShop = true;
                throw refused;
              }
              return data;
            });
          })
          .then(function () {
            /* The piece is in the bag now. If the bag cannot be drawn afresh, the bag page shows it. */
            return refreshBag().then(
              function () {
                busy = false;
                refresh(false);
                if (!openSheet('cart')) window.location.href = routes.cart;
              },
              function () {
                window.location.href = routes.cart;
              }
            );
          })
          .catch(function (error) {
            busy = false;
            refresh(false);
            var message = toastNode ? toastNode.getAttribute('data-error') : '';
            toast(message);
            if (errorNode) {
              errorNode.textContent = (error.fromShop && error.message) || message;
              errorNode.hidden = false;
            }
          });
      });
    }
  }

  /* ---------- Bag ---------- */
  function refreshBag() {
    var separator = routes.root.indexOf('?') > -1 ? '&' : '?';
    return fetch(routes.root + separator + 'sections=xo-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var html = sections['xo-cart-drawer'];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var next = $('[data-xo-cart]', fresh);
        var now = $('#xo-cart [data-xo-cart]');
        if (next && now) {
          now.innerHTML = next.innerHTML;
          now.removeAttribute('aria-busy');
        }
        var count = $('.xo-sheet__title .xo-count', fresh);
        $all('[data-xo-cart-count]').forEach(function (node) {
          node.textContent = count ? count.textContent : '0';
        });
      });
  }

  /* A line Shopify sends when it does not change a quantity, for example when no more pieces are in stock. */
  function bagMessage(text) {
    var host = $('[data-xo-cart-page]') || $('#xo-cart [data-xo-cart]');
    if (!host) return;
    var old = $('.xo-bag__msg', host);
    if (old) old.parentNode.removeChild(old);
    if (!text) return;
    var note = document.createElement('p');
    note.className = 'xo-bag__msg';
    note.setAttribute('role', 'status');
    note.textContent = text;
    var lines = $('.xo-lines', host);
    if (lines) lines.parentNode.insertBefore(note, lines);
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-xo-qty]');
    if (!control || !window.fetch) return;
    var line = control.closest('[data-xo-line]');
    if (!line) return;
    event.preventDefault();
    var box = control.closest('[data-xo-cart]');
    if (box) box.setAttribute('aria-busy', 'true');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.getAttribute('data-xo-line'), quantity: parseInt(control.getAttribute('data-xo-qty'), 10) })
    })
      .then(function (response) {
        if (response.ok) return '';
        return response.json().then(
          function (data) {
            return data.description || data.message || '';
          },
          function () {
            return '';
          }
        );
      })
      .then(function (refusal) {
        if ($('[data-xo-cart-page]')) {
          if (!refusal) {
            window.location.reload();
            return null;
          }
          bagMessage(refusal);
          return null;
        }
        return refreshBag().then(function () {
          bagMessage(refusal);
        });
      })
      .catch(function () {
        window.location.href = routes.cart;
      });
  });

  /* ---------- Header menu on a touch screen ---------- */
  /* The submenus open on hover. A finger cannot hover: there the first tap on Women, Men or The Brand opens the
     submenu, a second tap follows the link, and a tap anywhere else closes it. */
  function initNav() {
    var items = $all('.xo-nav__item.has-sub');
    if (!items.length) return;
    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) item.classList.remove('is-open');
      });
    }
    items.forEach(function (item) {
      var link = $('.xo-nav__link', item);
      if (!link) return;
      var hold = false;
      link.addEventListener('pointerdown', function (event) {
        hold = false;
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        if (item.classList.contains('is-open')) return;
        closeAll(item);
        item.classList.add('is-open');
        hold = true;
      });
      link.addEventListener('click', function (event) {
        if (!hold) return;
        hold = false;
        event.preventDefault();
      });
    });
    document.addEventListener('pointerdown', function (event) {
      if (!event.target.closest('.xo-nav__item.is-open')) closeAll(null);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  }

  /* Coming back with the browser's back button shows the page as it was left. The bag may have changed since. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && window.fetch) refreshBag().catch(function () {});
  });

  /* ---------- Small things ---------- */
  /* The country selector sends itself when a country is chosen. With the keyboard, arrow keys change the value step
     by step in some browsers: there it is sent on Enter or on leaving the field, not at every step. */
  var byKeyboard = false;
  document.addEventListener('keydown', function (event) {
    var field = event.target;
    if (!field.matches || !field.matches('[data-xo-autosubmit]')) return;
    if (event.key === 'Enter') {
      if (field.form && field.value !== field.getAttribute('data-first')) field.form.submit();
      return;
    }
    if (event.key !== 'Tab') byKeyboard = true;
  });
  document.addEventListener('pointerdown', function (event) {
    if (event.target.matches && event.target.matches('[data-xo-autosubmit]')) byKeyboard = false;
  });
  document.addEventListener('focusin', function (event) {
    var field = event.target;
    if (field.matches && field.matches('[data-xo-autosubmit]') && !field.hasAttribute('data-first')) field.setAttribute('data-first', field.value);
  });
  document.addEventListener('focusout', function (event) {
    var field = event.target;
    if (!field.matches || !field.matches('[data-xo-autosubmit]')) return;
    if (byKeyboard && field.form && field.hasAttribute('data-first') && field.value !== field.getAttribute('data-first')) field.form.submit();
    byKeyboard = false;
  });
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-xo-autosubmit]') || !event.target.form) return;
    if (byKeyboard) return;
    event.target.form.submit();
  });

  function initNotify() {
    var field = $('[data-xo-notify]');
    if (!field || field.value) return;
    var piece = new URLSearchParams(window.location.search).get('notify');
    if (piece) field.value = say('notify', 'Please let me know when the %s is available.').replace('%s', piece);
  }

  /* A film (the editorial opener, the film opener): it is only fetched and played on wide screens, while it is in
     view, and not when the visitor asked for less motion. On the phone the frame is not shown, so nothing is loaded.
     A button beside it stops and starts it; once the visitor has stopped it, it stays stopped. */
  function initFilms() {
    var films = $all('[data-xo-film]');
    if (!films.length || !window.matchMedia) return;
    var wide = window.matchMedia('(min-width: 900px)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    films.forEach(function (film) {
      var inView = true;
      var held = still.matches;
      var frame = film.closest('.xo-film');
      var toggle = frame ? $('[data-xo-film-toggle]', frame) : null;
      function label() {
        if (!toggle) return;
        toggle.textContent = held ? toggle.getAttribute('data-play') : toggle.getAttribute('data-pause');
        toggle.setAttribute('aria-label', held ? say('playFilm', 'Play the film') : say('pauseFilm', 'Pause the film'));
      }
      film.addEventListener('playing', function () {
        film.classList.add('is-on');
      });
      function update() {
        if (wide.matches && !held && inView && film.offsetParent !== null) {
          var started = film.play();
          if (started && started.catch) started.catch(function () {});
        } else {
          film.pause();
        }
      }
      if (toggle) {
        toggle.addEventListener('click', function () {
          held = !held;
          label();
          update();
        });
      }
      label();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          update();
        }).observe(film.parentNode);
      } else {
        update();
      }
      if (wide.addEventListener) wide.addEventListener('change', update);
    });
  }

  /* Colours of the season: the colour of a field is read from the photo of the piece. The photo is drawn small on
     a canvas; in the part where the garment is (the chest, or the legs for trousers) the most common colour is taken,
     leaving out the pale background. Until then, and if the photo cannot be read, the swatch colour stands. */
  function initTones() {
    var tiles = $all('[data-xo-tone][data-photo]');
    if (!tiles.length || !document.createElement('canvas').getContext) return;
    function luminance(r, g, b) {
      return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    }
    function read(tile) {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function () {
        try {
          var w = 60;
          var h = Math.max(1, Math.round((image.naturalHeight / image.naturalWidth) * w));
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(image, 0, 0, w, h);
          var low = tile.getAttribute('data-region') === 'low';
          var y0 = Math.round(h * (low ? 0.56 : 0.3));
          var y1 = Math.round(h * (low ? 0.86 : 0.6));
          var x0 = Math.round(w * 0.32);
          var x1 = Math.round(w * 0.68);
          var data = context.getImageData(x0, y0, x1 - x0, y1 - y0).data;
          var bins = {};
          var sums = {};
          var best = null;
          var limit = 0.9;
          var pass;
          for (pass = 0; pass < 2 && !best; pass++) {
            bins = {};
            sums = {};
            for (var i = 0; i < data.length; i += 4) {
              var r = data[i];
              var g = data[i + 1];
              var b = data[i + 2];
              if (luminance(r, g, b) > limit) continue;
              var key = (r >> 4) + ',' + (g >> 4) + ',' + (b >> 4);
              bins[key] = (bins[key] || 0) + 1;
              var sum = sums[key] || (sums[key] = [0, 0, 0]);
              sum[0] += r;
              sum[1] += g;
              sum[2] += b;
            }
            for (var name in bins) {
              if (!best || bins[name] > bins[best]) best = name;
            }
            limit = 1.01;
          }
          if (!best) return;
          var n = bins[best];
          var tone = [Math.round(sums[best][0] / n), Math.round(sums[best][1] / n), Math.round(sums[best][2] / n)];
          tile.style.setProperty('--c', 'rgb(' + tone.join(' ') + ')');
          tile.classList.toggle('is-dark', luminance(tone[0], tone[1], tone[2]) < 0.49);
        } catch (error) {}
      };
      image.src = tile.getAttribute('data-photo');
    }
    if ('IntersectionObserver' in window) {
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          watcher.unobserve(entry.target);
          read(entry.target);
        });
      }, { rootMargin: '400px 0px' });
      tiles.forEach(function (tile) {
        watcher.observe(tile);
      });
    } else {
      tiles.forEach(read);
    }
  }

  function init() {
    initView();
    initTones();
    initColourFilter();
    initZoom();
    initFilms();
    initNav();
    $all('[data-xo-product]').forEach(initProduct);
    initNotify();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
